import { Colors } from '../../consts/Colors.js';

export default class MenuA2 extends Phaser.GameObjects.Container {
    constructor(scene, menuData) {
        super(scene, 960, 220, []);
        scene.add.existing(this);
        this.scene = scene;
        this.menuData = menuData;
        this.allBtns = [];

        this.backRect = this.scene.add.rexRoundRectangle(0, 0, 1680, 140, 15, Colors.Elmt.MidOrange).setOrigin(0.5);
        this.add(this.backRect);

        // Create buttons via helper to avoid duplication
        this.createButton(-590, this.menuData[0], 1);
        this.createButton(0, this.menuData[1], 2);
        this.createButton(590, this.menuData[2], 3);
        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });

        // Selection highlight rectangle (stroke only)
        this.highlightRect = this.scene.add.rexRoundRectangle(-605, -20, 515, 140, 15, Colors.Elmt.LightOrange, 0).setOrigin(0.5);
        this.add(this.highlightRect);
        this.highlightRect.setStrokeStyle(4, Colors.Elmt.Black);
    }

    moveStrock(x, i) {
        this.scene.tweens.add({
            targets: this.highlightRect,
            x: x,
            duration: 300,
            ease: 'Power2',
            onComplete: () => {
                this.setShow(i)
                this.allBtns.filter(b => b !== this[`btn${i}`]).forEach(b => {
                    b.isSelected = false;
                    if (!b.isHide) {
                        this.setVeille(this.allBtns.indexOf(b) + 1)
                    }
                })
            }
        })
    }

    setHide(i) {
        if (!this[`btn${i}`].isHide) {
            this.setVeille(i)
            return
        }
        this[`btn${i}`].isHide = true;
        this[`btnText${i}`].setAlpha(0);
        this[`btn${i}`].setAlpha(0);
    }

    setShow(i) {
        this[`btn${i}`].isHide = false;
        this[`btnText${i}`].setAlpha(1);
        this[`btn${i}`].setAlpha(1);
        this[`btn${i}`].isSelected = true;
    }

    setVeille(i) {
        this[`btnText${i}`].setAlpha(0.5);
        this[`btn${i}`].setAlpha(0.5);
    }

    setMenuState(i, moveStrock = false) {
        if (moveStrock) {
            const targetX = this.getTargetX(i);
            const targetLevel = i
            this.scene.tweens.add({
                targets: this.highlightRect,
                x: targetX,
                duration: 300,
                ease: 'Power2',
                onComplete: () => {
                    console.log("setMenuState", i);
                    // Generic state update based on selected index (1-based)
                    for (let idx = 1; idx <= this.allBtns.length; idx++) {
                        if (idx === i) {
                            this.setShow(idx);
                        } else if (idx < i) {
                            this.setVeille(idx);
                        } else {
                            this.setHide(idx);
                        }
                    }
                    // this.highlightRect.x = this.getTargetX(i);
                    // this.scene.part = i
                    // this.setMenuState(i);
                    // this.scene.screenManager.changePart(i);
                }
            });
        } else {
            for (let idx = 1; idx <= this.allBtns.length; idx++) {
                if (idx === i) {
                    this.setShow(idx);
                } else if (idx < i) {
                    this.setVeille(idx);
                } else {
                    this.setHide(idx);
                }
            }

        }

    }

    // Helpers
    createButton(x, label, index) {
        const btn = this.scene.add.rectangle(x, 0, 500, 140, Colors.Elmt.LightOrange, 0).setOrigin(0.5);
        this.add(btn);
        btn.setInteractive({ useHandCursor: true });
        const txt = this.scene.createTextElement(x, 0, label);
        this.add(txt);
        // Initial state: first shown, others hidden
        btn.isSelected = index === 1;
        btn.isHide = index !== 1;
        this[`btn${index}`] = btn;
        this[`btnText${index}`] = txt;
        this.allBtns.push(btn);
        btn.on('pointerdown', () => this.onButtonClick(index));
    }

    onButtonClick(i) {
        this.clickSound.play();
        console.log("Button clicked: ", i);
        const targetX = this.getTargetX(i);
        const targetLevel = i
        this.scene.tweens.add({
            targets: this.highlightRect,
            x: targetX,
            duration: 300,
            ease: 'Power2',
            onComplete: () => {
                this.scene.part = i
                this.setMenuState(i);
                this.scene.screenManager.changePart(i);
            }
        });
    }

    getTargetX(i) {
        return [-590, 0, 590][i - 1];
    }

    // getLevelForIndex(i) {
    //     if (i === 1) return 0;
    //     if (i === 2) return 5;
    //     return 7;
    // }
}
